/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export const errorCodes = Object.freeze({
  INVALID_DATA: "invalid_data",
  DUPLICATE_ID: "duplicate_id",
  DUPLICATE_SHORTCUT: "duplicate_shortcut"
});

export const MODIFIER_KEYS = ["alt", "ctrl", "meta", "shift"];
export const KEYWORDS_TO_REMOVE = ["digit", "key"];
export const KEYS_TO_DISPLAY_LABELS = Object.freeze({
  meta: "⌘",
  ctrl: "Ctrl",
  shift: "⇧",
  alt: "⎇",
  numpadadd: "+",
  numpadsubtract: "-",
  delete: "Delete",
  backspace: "Backspace",
  z: "Z",
  shiftMac: "Shift"
});
